/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState } from 'react';
import { Button } from '../Button';
import styles from './Accordion.module.scss';
export const Accordion = ({ buttonText, accordionText }) => {
    const [open, setOpen] = useState(false);
    return (<div className={styles.accordion}>
      <div className={styles.buttonContainer} onClick={() => setOpen(!open)} role='presentation'>
        <Button variant='text'>{buttonText}</Button>
        <img className={open ? styles.accordionOpen : styles.accordionClosed} src='https://www.haven.com/assets/owners/shared/chevron-down.svg' alt=''/>
      </div>
      {open && <p className={styles.accordionTextOpen}>{accordionText}</p>}
    </div>);
};
